export const columnsDataDevelopment = ["ID", "TITLE", "DIFFICULTY", "LESSON","QUIZZ", "CREATED AT", "ACTION"];
